import { render, staticRenderFns } from "./followdetails.vue?vue&type=template&id=111db6bd&scoped=true"
import script from "./followdetails.vue?vue&type=script&lang=js"
export * from "./followdetails.vue?vue&type=script&lang=js"
import style0 from "./followdetails.vue?vue&type=style&index=0&id=111db6bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111db6bd",
  null
  
)

export default component.exports